/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  makeStyles,
  Switch,
  TextField,
  Tooltip as TooltipMaterial,
  Typography,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Button from 'components/Button';
import DatePicker from 'components/DatePicker';
import Tooltip from 'components/ExplanationHover';
import InputAdornmentChip from 'components/InputAdornmentChip';
import Loading from 'components/Loading';
import Slider from 'components/Slider';
import Permission from 'components/ValidPermission';
import { Form, Formik } from 'formik';
import {
  CheckCircle as CheckCircleIcon,
  Update as UpdateIcon,
} from '@material-ui/icons';
import i18n from 'i18n';
import {
  CompanyData,
  PartnerData,
  PermissionsData,
  RolesEnum,
} from 'modules/authenticate/interfaces';
import {
  acceptStatusPendingRequest,
  extendCompletionDateRequest,
  getEnvironmentMonitoringRequest,
  getProviderResourcesRequest,
  removeEnvironmentRequest,
  setProductionEnvironmentRequest,
} from 'modules/environments/actions';
import {
  EnvironmentFields,
  EnvironmentStatus,
  ModelFields,
  ModelTypeEnum,
  ProviderResourcesFields,
  ProviderResourcesProps,
  VirtualizerEnum,
} from 'modules/environments/interfaces';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import AlarmAddIcon from '@material-ui/icons/AlarmAdd';
import { useHistory, useParams } from 'react-router-dom';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import ApplicationState from 'store/interfaces';
import {
  applyI18n,
  formatDateForEnvStatus,
  formatDateForEnvStatusForApprove,
  formatDateForEnvStatusUpdate,
  formatHour,
  formatModelName,
  parseHour,
  removeFields,
  superUser,
} from 'utils/helpers';
import clsx from 'clsx';
import { isClientOperator } from 'utils/role';
import { getPartnerRequest } from 'modules/partners/actions';
import { PartnerFormFields } from 'modules/partners/interfaces';
import TitleDivider from 'components/TitleDivider';
import DynamicTextField from 'components/DynamicTextField';
import moment from 'moment';
import screenFields from './formFields';
import { initial } from './initalValues';
import validationSchema from './schema';
import styles, { overrideSlider } from './styles';
import schemaExtendDate from './schemaExtendDate';
import extendFields from './screenFields';
import {
  changeFieldValueByVirtualizer,
  getUserConnection,
  makeOptionsProductType,
  SwitchComponentProps,
  TitleDividerComponentProps,
  WEB_PORT_VIRTUALIZERS,
} from './utils';

const useStyles = makeStyles(styles);

interface Props {
  companySelected: CompanyData | null;
  environmentModel?: ModelFields[];
  initialValues?: EnvironmentFields | null;
  isEdit?: boolean;
  isLoading?: boolean;
  partnerDetails: PartnerFormFields | null;
  partnerSelected: PartnerData | null;
  permissions?: PermissionsData;
  providerResources?: ProviderResourcesProps['listProvidersResources'];
  role?: RolesEnum;
  getEnvironmentMonitoringRequest: (props) => void;
  getPartnerRequest: (id: string) => void;
  getProviderResourcesRequest: (values) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  onSubmit: (values: any, form: any) => void;
  removeEnvironmentRequest: (props) => void;
  setProductionEnvironmentRequest: (props) => void;
  acceptStatusPendingRequest: (props) => void;
  extendCompletionDateRequest: (props) => void;
}

function TitleDividerComponent({
  children,
  tooltipTitle,
}: TitleDividerComponentProps) {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.titleContainer}>
      <Typography variant="h6" component="h2">
        {children}
      </Typography>
      {!!tooltipTitle && <Tooltip title={tooltipTitle} />}
    </Grid>
  );
}

const SwitchComponent = ({
  children,
  disabled,
  explanationHover,
  hidden,
  hover,
  id,
  isChecked,
  label,
  tooltipTitle,
  onChange,
}: SwitchComponentProps) => {
  const classes = useStyles();

  return hidden ? null : (
    <Grid item container spacing={2}>
      <Grid item className={classes.switchContainer} xs={12}>
        <TooltipMaterial
          disableFocusListener={!disabled}
          disableHoverListener={!disabled}
          title={hover}
          arrow
          placement="left"
        >
          <FormControlLabel
            classes={{ label: classes.switchLabel, root: classes.switchRoot }}
            control={
              <Switch
                disabled={disabled}
                id={id}
                checked={isChecked}
                onChange={onChange}
                classes={{ colorSecondary: classes.switchChecked }}
                size="small"
              />
            }
            label={label}
          />
        </TooltipMaterial>
        {!!tooltipTitle && <Tooltip title={tooltipTitle} />}
        {!!explanationHover && explanationHover}
      </Grid>
      {!!children && isChecked && children}
    </Grid>
  );
};

const FormEnvironment = ({
  companySelected,
  environmentModel = [],
  initialValues,
  isEdit = false,
  isLoading,
  partnerDetails,
  partnerSelected,
  permissions,
  providerResources,
  role,
  getEnvironmentMonitoringRequest,
  onSubmit,
  getPartnerRequest,
  getProviderResourcesRequest,
  modalOpen,
  modalClose,
  removeEnvironmentRequest,
  setProductionEnvironmentRequest,
  acceptStatusPendingRequest,
  extendCompletionDateRequest,
}: Props) => {
  const classes = useStyles();
  const [pendency, setPendency] = React.useState<boolean>(false);
  const [extendDateField, setExtendDateField] = React.useState<boolean>(false);
  const [dateError, setDateError] = React.useState<boolean>(false);
  const { id, section } = useParams<{ id: string; section: string }>();
  const history = useHistory();
  const [
    listProviderResources,
    setListProviderResources,
  ] = React.useState<ProviderResourcesFields | null>();
  const [currentStatus, setCurrentStatus] = React.useState<
    string | number | boolean | Date | string[] | undefined
  >('');
  const [
    useDailyPublicationsLimit,
    setUseDailyPublicationsLimit,
  ] = React.useState<boolean>(
    initialValues?.publication?.limit_instance_blocking_publications_daily !==
      null
  );

  const [dailyPublicationsLimit, setDailyPublicationsLimit] = React.useState<
    string | number | null | undefined
  >(initialValues?.publication?.limit_instance_blocking_publications_daily);

  const filterFields = (fields: GenericFormItem[]): GenericFormItem[] => {
    const removeFieldsID = isEdit ? [] : ['environment_uuid', 'trusted_users'];
    return removeFields(removeFieldsID, applyI18n(fields));
  };

  React.useEffect(() => {
    if (isEdit) {
      getEnvironmentMonitoringRequest({ id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getEnvironmentMonitoringRequest, id]);

  React.useEffect(() => {
    if (!isEdit && partnerSelected) {
      getPartnerRequest(partnerSelected?.id);
    }
  }, [partnerSelected, isEdit, getPartnerRequest]);

  const validBlockFields = values => {
    let data = null;
    if (values) {
      data = {
        ...values,
        publication: {
          ...values?.publication,
          schedule_instances_blocking_check: String(
            !!values?.publication?.schedule_instances_blocking?.time ||
              !!values?.publication?.schedule_instances_blocking?.warning_emails
          ),
          schedule_instances_blocking: {
            ...values?.publication?.schedule_instances_blocking,
            time: parseHour(
              values?.publication?.schedule_instances_blocking?.time,
              'HH:mm:ss'
            ),
          },
        },
      };
    }

    return data;
  };

  const initialParsedValues = React.useMemo(() => {
    const base = validBlockFields(initialValues) || {
      ...initial,
      partner_uuid: partnerSelected?.id || '',
      partner: {
        provider: {
          oci_config_profile_name: '',
        },
      },
      env_status: EnvironmentStatus.PENDING,
    };
    if (initialValues) {
      return {
        ...base,
        instance_observability: initialValues.instance_observability ?? {
          enabled: false,
        },
      };
    }
    return base;
  }, [initialValues, partnerSelected]);

  const isValidTimestamp = (value: any): boolean => {
    return Number.isInteger(value) && value > 0;
  };

  const formatDateFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = (values: any, form: any) => {
    let data = {
      ...values,
      publication: {
        ...values?.publication,
        schedule_instances_blocking: {
          ...values?.publication?.schedule_instances_blocking,
          time:
            values?.publication?.schedule_instances_blocking_check === 'false'
              ? null
              : formatHour(
                  values?.publication?.schedule_instances_blocking?.time
                ),
        },
        limit_instance_blocking_publications_daily: useDailyPublicationsLimit
          ? dailyPublicationsLimit
          : null,
      },
      user_connection: getUserConnection(values),
      env_status: values?.env_status || EnvironmentStatus.PENDING,
    };

    if (isValidTimestamp(data.completion_date)) {
      data.completion_date = formatDateFromTimestamp(data.completion_date);
    }

    if (!isEdit && !!partnerDetails?.frontend?.enable_new_interface) {
      data = {
        ...data,
        zero_trust: {
          enabled: true,
          port: 33450,
          allow_list: [],
        },
      };
    }

    if (isEdit) {
      data = {
        ...data,
        instance_observability: {
          enabled: !!values?.instance_observability?.enabled,
        },
      };
    }

    onSubmit(data, form);
    setExtendDateField(false);
  };

  const handleRemoveEnvironment = () =>
    modalOpen({
      title: `${i18n.t('REMOVE_KEY')} ${initialValues?.name}`,
      content: i18n.t('ENVIRONMENTS_PAGE.REMOVE_DESCRIPTION_KEY'),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              removeEnvironmentRequest({
                environmentUuid: id,
                company_uuid: companySelected?.id,
                partner_uuid: partnerSelected?.id,
              });
              history.push('/environments');
              modalClose();
            }}
          >
            {i18n.t('REMOVE_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });

  const handleSubmitCompletionDatePropose = values => {
    extendCompletionDateRequest({
      id,
      completion_date_proposed: formatDateForEnvStatusUpdate(
        values?.completion_date_proposed
      ),
      completion_date_reason: values?.completion_date_reason,
    });
    modalClose();
  };

  const handleOpenExtend = () =>
    modalOpen({
      title: i18n.t('EXTEND_COMPLETION_DATE_KEY'),
      content: (
        <Grid container>
          <Typography
            style={{ margin: '12px 4px 8px 4px', fontSize: 12 }}
            component="div"
          >
            {`${i18n.t('CURRENT_COMPLETION_DATE_KEY')}: `}
            <Box fontWeight="bold" display="inline">
              {formatDateForEnvStatusForApprove(initialValues?.completion_date)}
            </Box>
          </Typography>
          <TitleDivider
            overrideClasses={{
              title: { margin: '12px 4px 8px 4px', fontSize: 12 },
            }}
          >
            {i18n.t('REQUEST_NEW_COMPLETION_DATE_KEY')}
          </TitleDivider>
          <Formik
            initialValues={{
              completion_date_proposed:
                moment(initialValues?.completion_date) <
                moment(new Date(), 'DD-MM-YYYY')
                  ? moment(new Date(), 'DD-MM-YYYY')
                      .add(1, 'days')
                      .toDate()
                  : moment(initialValues?.completion_date, 'YYYY-MM-DD')
                      .add(1, 'days')
                      .toDate(),
              completion_date_reason: '',
            }}
            enableReinitialize
            validationSchema={schemaExtendDate(
              moment(initialValues?.completion_date, 'YYYY-MM-DD').add(
                1,
                'days'
              )
            )}
            validateOnChange
            validateOnBlur
            onSubmit={handleSubmitCompletionDatePropose}
          >
            {({ setFieldValue, errors, values, submitForm }) => {
              return (
                <React.Fragment>
                  <Form style={{ width: '100%' }}>
                    <Grid container>
                      <Grid container className={classes.fields}>
                        <GenericForm
                          fields={values}
                          screenFields={[
                            {
                              gridXs: 12,
                              label: i18n.t('NEW_COMPLETION_DATE_KEY'),
                              stateKey: 'completion_date_proposed',
                              validateOnChange: true,
                              isDate: true,
                              minDate:
                                moment(initialValues?.completion_date) <
                                moment(new Date(), 'DD-MM-YYYY')
                                  ? moment(new Date(), 'DD-MM-YYYY')
                                      .add(1, 'days')
                                      .toDate()
                                  : moment(
                                      initialValues?.completion_date,
                                      'YYYY-MM-DD'
                                    )
                                      .add(1, 'days')
                                      .toDate(),
                            },
                          ]}
                          setFieldValue={setFieldValue}
                          errors={errors}
                        />
                        <DynamicTextField
                          {...extendFields[0]}
                          setFieldValue={setFieldValue}
                          value={values?.completion_date_reason}
                          errors={errors}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      justify="flex-end"
                      style={{ marginTop: 12 }}
                    >
                      <Button
                        submitButton
                        id="confirm-button"
                        onClick={submitForm}
                        isLoading={isLoading}
                      >
                        {i18n.t('CONFIRM_REQUEST_KEY')}
                      </Button>
                      <Button
                        id="cancel-button"
                        variant="outlined"
                        onClick={modalClose}
                      >
                        {i18n.t('CANCEL_KEY')}
                      </Button>
                    </Grid>
                  </Form>
                </React.Fragment>
              );
            }}
          </Formik>
        </Grid>
      ),
    });

  React.useEffect(() => {
    if (!isEdit) {
      getProviderResourcesRequest({
        environment: '',
      });
    }
  }, [getProviderResourcesRequest, isEdit]);

  React.useEffect(() => {
    if (providerResources?.results) {
      setListProviderResources(providerResources?.results);
    }
  }, [providerResources]);

  if (isLoading) {
    return <Loading />;
  }

  const setFieldValueByProviderType = (key, value, values, setFieldValue) => {
    setFieldValue(key, value);
    if (values?.product_type === 'spot_period') {
      const defaultValue = 'dedicated';
      setFieldValue('product_type', defaultValue);
    }
    setFieldValue('provider.region', '');
    setFieldValue(
      'publication.type',
      value === 'oci'
        ? ModelTypeEnum.bootVolumeBackup
        : ModelTypeEnum.customImage
    );
  };

  const setFieldValueByProductType = (key, value, setFieldValue) => {
    setFieldValue(key, value);
    if (key === 'product') {
      const defaultValue = 'dedicated';
      setFieldValue('product_type', defaultValue);
    }
  };

  const setIncreaseLicenseLimitDefaultValue = (value, setFieldValue) => {
    setFieldValue('licenses.increase_license_limit_each', value ? 1 : 0);
  };

  const mapVirtualizer = (virtualizer: VirtualizerEnum | string): string => {
    const options = {
      [VirtualizerEnum.CONNECT]: 'ConnectSky',
      [VirtualizerEnum.RDP]: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
      [VirtualizerEnum.RDP_DIRECT]: 'Microsoft Remote Desktop (Direct Connect)',
      [VirtualizerEnum.RDP_APP]: 'Microsoft Remote Desktop (RemoteApp)',
      [VirtualizerEnum.CONNECT_DIRECT]: 'ConnectSky (Direct Connect)',
      [VirtualizerEnum.TSPLUS]: 'TSPlus (WebBrowser HTML5)',
      [VirtualizerEnum.TSPLUS_REMOTE_APP]: 'TSPlus (RemoteApp)',
      [VirtualizerEnum.TSPLUS_ALL]: 'TSPlus (WebBrowser HTML and RemoteApp)',
      [VirtualizerEnum.ASPW]: 'ASPW (WebBrowser)',
      [VirtualizerEnum.ASPW_ALL]: 'ASPW (WebBrowser and RemoteApp)',
    };

    return options[virtualizer] || virtualizer;
  };

  interface Option {
    value: EnvironmentStatus;
    label: string;
  }

  const options = [
    {
      value: EnvironmentStatus.DEMONSTRATION,
      label: i18n.t('ENVIRONMENT_STATUS.DEMONSTRATION_KEY'),
    },
    {
      value: EnvironmentStatus.DEPLOYMENT,
      label: i18n.t('ENVIRONMENT_STATUS.DEPLOYMENT_KEY'),
    },
    {
      value: EnvironmentStatus.DEVELOPMENT,
      label: i18n.t('ENVIRONMENT_STATUS.DEVELOPMENT_KEY'),
    },
    {
      value: EnvironmentStatus.HOMOLOGATION,
      label: i18n.t('ENVIRONMENT_STATUS.HOMOLOGATION_KEY'),
    },
    {
      value: EnvironmentStatus.MIGRATION,
      label: i18n.t('ENVIRONMENT_STATUS.MIGRATION_KEY'),
    },
    {
      value: EnvironmentStatus.PRODUCTION,
      label: i18n.t('ENVIRONMENT_STATUS.PRODUCTION_KEY'),
    },
    {
      value: EnvironmentStatus.PENDING,
      label: i18n.t('ENVIRONMENT_STATUS.PENDING_KEY'),
      hidden: isEdit,
    },
  ].filter(option => !option?.hidden);

  let filteredOptions: Option[] = [];

  if (
    role === RolesEnum.superAdmin ||
    initialValues?.env_status === EnvironmentStatus.PENDING ||
    !isEdit
  ) {
    filteredOptions = options;
  } else if (role === RolesEnum.admin || role === RolesEnum.operator) {
    if (
      initialValues?.env_status === EnvironmentStatus.DEPLOYMENT ||
      initialValues?.env_status === EnvironmentStatus.HOMOLOGATION ||
      initialValues?.env_status === EnvironmentStatus.MIGRATION
    ) {
      filteredOptions = options.filter(
        option => option.value === EnvironmentStatus.PRODUCTION
      );
    } else if (
      initialValues?.env_status === EnvironmentStatus.DEMONSTRATION ||
      initialValues?.env_status === EnvironmentStatus.PRODUCTION ||
      initialValues?.env_status === EnvironmentStatus.DEVELOPMENT
    ) {
      filteredOptions = [];
    }
  }

  const currentDate = new Date();

  return partnerSelected || (!companySelected && superUser(role)) ? (
    <>
      <Grid item xs={12} className={classes.formContent}>
        <Formik
          initialValues={initialParsedValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur
          validateOnChange
          enableReinitialize
        >
          {({ setFieldValue, submitForm, errors, values, isValid }) => (
            <>
              <Grid item container xs={12} spacing={2}>
                <TitleDividerComponent>
                  {i18n.t('GENERAL_SETTINGS_KEY')}
                </TitleDividerComponent>
                <Grid
                  container
                  spacing={2}
                  justify="flex-start"
                  className={clsx(classes.statusGrid, {
                    [classes.statusSection]: section === 'status',
                  })}
                >
                  <Grid container spacing={2} className={classes.displayFlex}>
                    {(role === RolesEnum.admin ||
                      role === RolesEnum.operator) &&
                      initialValues?.env_status !== EnvironmentStatus.PENDING &&
                      isEdit && (
                        <Grid xs={4} item className={classes.dateAndPending}>
                          <>
                            <TextField
                              value={i18n.t(
                                `ENVIRONMENT_STATUS.${initialValues?.env_status?.toUpperCase()}_KEY`
                              )}
                              fullWidth
                              variant="outlined"
                              label={i18n.t('STATUS_KEY')}
                              disabled={true}
                            />
                          </>
                          {(initialValues?.env_status ===
                            EnvironmentStatus.DEPLOYMENT ||
                            initialValues?.env_status ===
                              EnvironmentStatus.HOMOLOGATION ||
                            initialValues?.env_status ===
                              EnvironmentStatus.MIGRATION) &&
                            (role === RolesEnum.admin ||
                              role === RolesEnum.operator) &&
                            permissions?.can_manage_environment_status && (
                              <Button
                                onClick={() => {
                                  modalOpen({
                                    title: i18n.t(
                                      'MAKE_ENVIRONMENT_PRODUCTIVE_KEY'
                                    ),
                                    content: i18n.t(
                                      'CONFIRM_MAKE_ENVIRONMENT_PRODUCTIVE_KEY'
                                    ),
                                    footer: (
                                      <Grid>
                                        <Button
                                          submitButton
                                          id="submit-button"
                                          onClick={() => {
                                            setProductionEnvironmentRequest({
                                              id,
                                              status: {
                                                env_status: 'production',
                                                completion_date: null,
                                              },
                                            });
                                            modalClose();
                                          }}
                                        >
                                          {i18n.t('CONFIRM_KEY')}
                                        </Button>
                                        <Button
                                          id="cancel-button"
                                          variant="outlined"
                                          onClick={modalClose}
                                        >
                                          {i18n.t('CANCEL_KEY')}
                                        </Button>
                                      </Grid>
                                    ),
                                  });
                                }}
                                className={classes.setProduction}
                                endIcon={<CheckCircleIcon />}
                              >
                                {i18n.t('MAKE_ENVIRONMENT_PRODUCTIVE_KEY')}
                              </Button>
                            )}
                        </Grid>
                      )}
                    {(role === RolesEnum.superAdmin ||
                      initialValues?.env_status === 'pending' ||
                      !isEdit) && (
                      <GenericForm
                        overrideClasses={{
                          selectLabel: {
                            fontSize: 12,
                            fontWeight: 500,
                          },
                        }}
                        fields={values}
                        screenFields={[
                          {
                            gridXs: 12,
                            gridMd: 4,
                            label: i18n.t('STATUS_KEY'),
                            stateKey: 'env_status',
                            validateOnChange: true,
                            isSelect: true,
                            disabled:
                              !permissions?.can_manage_environment_status ||
                              (role !== RolesEnum.superAdmin &&
                                initialValues?.env_status ===
                                  EnvironmentStatus.PRODUCTION),
                            options: filteredOptions,
                          },
                        ]}
                        setFieldValue={(key, value) => {
                          setFieldValue(key, value);
                          setCurrentStatus(value);
                          if (
                            value === EnvironmentStatus.MIGRATION ||
                            value === EnvironmentStatus.HOMOLOGATION ||
                            value === EnvironmentStatus.DEPLOYMENT
                          ) {
                            setExtendDateField(true);
                            setFieldValue(key, value);
                            setFieldValue(
                              'completion_date',
                              value === EnvironmentStatus.DEPLOYMENT
                                ? currentDate.setDate(
                                    currentDate.getDate() + 90
                                  )
                                : currentDate.setDate(
                                    currentDate.getDate() + 30
                                  )
                            );
                          }
                          if (
                            value === EnvironmentStatus.PRODUCTION ||
                            value === EnvironmentStatus.DEVELOPMENT ||
                            value === EnvironmentStatus.DEMONSTRATION
                          ) {
                            setExtendDateField(false);
                            setFieldValue(key, value);
                            setFieldValue('completion_date', null);
                            setDateError(false);
                          }
                        }}
                        errors={errors}
                      />
                    )}
                    {(currentStatus === EnvironmentStatus.DEPLOYMENT ||
                      currentStatus === EnvironmentStatus.HOMOLOGATION ||
                      currentStatus === EnvironmentStatus.MIGRATION ||
                      initialValues?.env_status ===
                        EnvironmentStatus.DEPLOYMENT ||
                      initialValues?.env_status ===
                        EnvironmentStatus.HOMOLOGATION ||
                      initialValues?.env_status ===
                        EnvironmentStatus.MIGRATION) &&
                      currentStatus !== EnvironmentStatus.DEVELOPMENT &&
                      currentStatus !== EnvironmentStatus.PRODUCTION &&
                      currentStatus !== EnvironmentStatus.DEMONSTRATION && (
                        <Grid item xs={4}>
                          <DatePicker
                            id="completion_date"
                            type="date"
                            label={i18n.t('COMPLETION_DATE_KEY')}
                            keyValue="completion_date"
                            disablePast
                            value={formatDateForEnvStatus(
                              values?.completion_date
                            )}
                            helperText={
                              moment(values?.completion_date) <
                              moment(new Date(), 'DD-MM-YYYY')
                                ? i18n.t('COMPLETION_DATE_EXPIRED_KEY')
                                : undefined
                            }
                            minDate={moment(new Date(), 'DD-MM-YYYY').add(
                              1,
                              'days'
                            )}
                            setFieldsValue={(key, value) => {
                              setFieldValue(
                                key,
                                formatDateForEnvStatusUpdate(value)
                              );
                            }}
                            error={
                              ((currentStatus === EnvironmentStatus.MIGRATION ||
                                currentStatus ===
                                  EnvironmentStatus.HOMOLOGATION ||
                                currentStatus ===
                                  EnvironmentStatus.DEPLOYMENT) &&
                                String(values.completion_date) ===
                                  'Invalid date') ||
                              !moment(values.completion_date).isValid() ||
                              moment(values?.completion_date) <
                                moment(new Date(), 'DD-MM-YYYY')
                            }
                            onError={() => {
                              if (
                                ((currentStatus ===
                                  EnvironmentStatus.MIGRATION ||
                                  currentStatus ===
                                    EnvironmentStatus.HOMOLOGATION ||
                                  currentStatus ===
                                    EnvironmentStatus.DEPLOYMENT) &&
                                  String(values.completion_date) ===
                                    'Invalid date') ||
                                !moment(values.completion_date).isValid() ||
                                (moment(values?.completion_date) <
                                  moment(new Date(), 'DD-MM-YYYY') &&
                                  initialValues?.completion_date !==
                                    values?.completion_date)
                              ) {
                                setDateError(true);
                              } else {
                                setDateError(false);
                              }
                            }}
                            disabled={
                              !extendDateField ||
                              !permissions?.can_manage_environment_status
                            }
                          />
                        </Grid>
                      )}
                    <Grid xs={4} item className={classes.dateAndPendingGrid}>
                      <Grid item className={classes.dateAndPending}>
                        {initialValues?.completion_date &&
                          permissions?.can_manage_environment_status &&
                          !extendDateField &&
                          currentStatus !== EnvironmentStatus.DEVELOPMENT &&
                          currentStatus !== EnvironmentStatus.PRODUCTION &&
                          currentStatus !== EnvironmentStatus.DEMONSTRATION && (
                            <>
                              {(role === RolesEnum.superAdmin ||
                                (initialValues.completion_date_extendable &&
                                  (role === RolesEnum.operator ||
                                    role === RolesEnum.admin))) && (
                                <Button
                                  onClick={() => {
                                    if (role === RolesEnum.superAdmin) {
                                      setExtendDateField(!extendDateField);
                                    } else handleOpenExtend();
                                  }}
                                  className={classes.setExtend}
                                  endIcon={<AlarmAddIcon />}
                                >
                                  {i18n.t('EXTEND_KEY')}
                                </Button>
                              )}
                            </>
                          )}
                      </Grid>
                      <Grid item className={classes.displayFlex}>
                        {initialValues?.completion_date_change_request &&
                          initialValues?.env_status !==
                            EnvironmentStatus.PENDING &&
                          isEdit &&
                          currentStatus !== EnvironmentStatus.DEVELOPMENT &&
                          currentStatus !== EnvironmentStatus.PRODUCTION &&
                          currentStatus !== EnvironmentStatus.DEMONSTRATION &&
                          initialValues.env_status !==
                            EnvironmentStatus.DEVELOPMENT &&
                          initialValues.env_status !==
                            EnvironmentStatus.PRODUCTION &&
                          initialValues.env_status !==
                            EnvironmentStatus.DEMONSTRATION &&
                          (role === RolesEnum.admin ||
                            role === RolesEnum.operator) && (
                            <Grid
                              item
                              style={{ alignItems: 'center', display: 'flex' }}
                            >
                              <TooltipMaterial
                                arrow
                                title={
                                  initialValues?.completion_date_proposed
                                    ? i18n.t('PENDING_COMPLETION_DATE_KEY', {
                                        completion_date_proposed: formatDateForEnvStatusForApprove(
                                          initialValues?.completion_date_proposed
                                        ),
                                      })
                                    : i18n.t(
                                        'PENDING_COMPLETION_DATE_NO_DATE_KEY'
                                      )
                                }
                              >
                                <Typography className={classes.pending}>
                                  {i18n.t('EXTEND_REQUEST_KEY')}
                                  <UpdateIcon className={classes.pendingIcon} />
                                </Typography>
                              </TooltipMaterial>
                            </Grid>
                          )}
                        {initialValues?.completion_date_change_request &&
                          initialValues?.env_status !==
                            EnvironmentStatus.PENDING &&
                          initialValues.completion_date &&
                          permissions?.can_accept_pending_extension &&
                          currentStatus !== EnvironmentStatus.DEVELOPMENT &&
                          currentStatus !== EnvironmentStatus.PRODUCTION &&
                          currentStatus !== EnvironmentStatus.DEMONSTRATION &&
                          initialValues.env_status !==
                            EnvironmentStatus.DEVELOPMENT &&
                          initialValues.env_status !==
                            EnvironmentStatus.PRODUCTION &&
                          initialValues.env_status !==
                            EnvironmentStatus.DEMONSTRATION &&
                          !extendDateField &&
                          isEdit &&
                          role === RolesEnum.superAdmin && (
                            <Grid
                              item
                              style={{ alignItems: 'center', display: 'flex' }}
                            >
                              <Button
                                onClick={() => setPendency(!pendency)}
                                className={classes.validatePending}
                                endIcon={<UpdateIcon />}
                              >
                                {i18n.t('VALIDATE_PENDENCIES_KEY')}
                              </Button>
                            </Grid>
                          )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {(pendency || section === 'pendingStatus') &&
                  initialValues?.completion_date_change_request &&
                  role === RolesEnum.superAdmin && (
                    <Grid
                      container
                      className={classes.pendency}
                      justify="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: 12,
                              margin: '12px 12px 6px 12px',
                            }}
                            component="div"
                          >
                            {`${i18n.t('REQUESTER_KEY')}: `}
                            <Box fontWeight="bold" display="inline">
                              {initialValues?.completion_date_request_by
                                ? `${initialValues?.completion_date_request_by?.first_name} ${initialValues?.completion_date_request_by?.last_name} (${initialValues?.completion_date_request_by?.email})`
                                : '-'}
                            </Box>
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: 'flex',
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: 12,
                              margin: '0px 12px',
                            }}
                            component="div"
                          >
                            {`${i18n.t('COMPLETION_DATE_SOLICITATION_KEY')}: `}
                            <Box fontWeight="bold" display="inline">
                              {formatDateForEnvStatusForApprove(
                                initialValues?.completion_date_proposed
                              )}
                            </Box>
                          </Typography>
                        </Grid>
                        <Grid item style={{ display: 'flex' }}>
                          <Typography
                            style={{
                              fontSize: 12,
                              margin: '6px 0px 12px 12px',
                            }}
                            component="div"
                          >
                            {`${i18n.t('REASON_KEY')}: `}
                            <Box fontWeight="bold" display="inline">
                              {initialValues?.completion_date_reason}
                            </Box>
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid item>
                        <Button
                          onClick={() => {
                            modalOpen({
                              title: i18n.t('REFUSE_EXTEND_DATE_KEY'),
                              content: (
                                <>
                                  <Grid item>
                                    <Typography
                                      style={{ fontSize: 12, margin: 12 }}
                                      component="div"
                                    >
                                      {i18n.t(
                                        'REFUSE_EXTEND_DATE_DETAILS_KEY',
                                        {
                                          completion_date_proposed: formatDateForEnvStatusForApprove(
                                            initialValues?.completion_date_proposed
                                          ),
                                          completion_date: formatDateForEnvStatusForApprove(
                                            initialValues?.completion_date
                                          ),
                                        }
                                      )}
                                    </Typography>
                                  </Grid>
                                </>
                              ),
                              footer: (
                                <Grid>
                                  <Button
                                    submitButton
                                    id="submit-button"
                                    onClick={() => {
                                      acceptStatusPendingRequest({
                                        id,
                                        accept: false,
                                      });
                                      modalClose();
                                    }}
                                  >
                                    {i18n.t('CONFIRM_KEY')}
                                  </Button>
                                  <Button
                                    id="cancel-button"
                                    variant="outlined"
                                    onClick={modalClose}
                                  >
                                    {i18n.t('CANCEL_KEY')}
                                  </Button>
                                </Grid>
                              ),
                            });
                          }}
                          className={classes.refusePendency}
                          endIcon={<CloseIcon />}
                        >
                          {i18n.t('REFUSE_KEY')}
                        </Button>
                        <Button
                          onClick={() => {
                            modalOpen({
                              title: i18n.t('APPROVE_EXTEND_DATE_KEY'),
                              content: (
                                <>
                                  <Grid item>
                                    <Typography
                                      style={{ fontSize: 12, margin: 12 }}
                                      component="div"
                                    >
                                      {`${i18n.t(
                                        'NEW_COMPLETION_DATE_WILL_BE_KEY'
                                      )}: `}
                                      <Box fontWeight="bold" display="inline">
                                        {formatDateForEnvStatusForApprove(
                                          initialValues?.completion_date_proposed
                                        )}
                                      </Box>
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography
                                      style={{ fontSize: 12, margin: 12 }}
                                      component="div"
                                    >
                                      {`${i18n.t('EXTEND_REQUESTED_BY_KEY')}: `}
                                      <Box fontWeight="bold" display="inline">
                                        {initialValues?.completion_date_request_by
                                          ? `${initialValues?.completion_date_request_by?.first_name} ${initialValues?.completion_date_request_by?.last_name} (${initialValues?.completion_date_request_by?.email})`
                                          : '-'}
                                      </Box>
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography
                                      style={{ fontSize: 12, margin: 12 }}
                                      component="div"
                                    >
                                      {`${i18n.t('EXTEND_REASON_KEY')}: `}
                                      <Box fontWeight="bold" display="inline">
                                        {initialValues?.completion_date_reason}
                                      </Box>
                                    </Typography>
                                  </Grid>
                                </>
                              ),
                              footer: (
                                <Grid>
                                  <Button
                                    submitButton
                                    id="submit-button"
                                    onClick={() => {
                                      acceptStatusPendingRequest({
                                        id,
                                        accept: true,
                                      });
                                      modalClose();
                                    }}
                                  >
                                    {i18n.t('CONFIRM_KEY')}
                                  </Button>
                                  <Button
                                    id="cancel-button"
                                    variant="outlined"
                                    onClick={modalClose}
                                  >
                                    {i18n.t('CANCEL_KEY')}
                                  </Button>
                                </Grid>
                              ),
                            });
                          }}
                          className={classes.approvePendency}
                          endIcon={<CheckIcon />}
                        >
                          {i18n.t('APPROVE_KEY')}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                <GenericForm
                  overrideClasses={{
                    selectLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  fields={values}
                  screenFields={filterFields(
                    screenFields.generalSettings.slice(0, 4)
                  )}
                  setFieldValue={setFieldValue}
                  errors={errors}
                />
                <GenericForm
                  overrideClasses={{
                    selectLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  fields={values}
                  screenFields={filterFields([
                    {
                      gridXs: 12,
                      gridMd: 4,
                      label: i18n.t('PROVIDER_CLOUD_KEY'),
                      stateKey: 'provider.type',
                      isSelect: true,
                      validateOnChange: true,
                      disabled: isEdit,
                      options:
                        listProviderResources?.providers?.map(value => ({
                          value,
                          label: value.toUpperCase(),
                        })) || [],
                    },
                  ])}
                  setFieldValue={(key, value) => {
                    setFieldValueByProviderType(
                      key,
                      value,
                      values,
                      setFieldValue
                    );
                  }}
                  errors={errors}
                />
                {values?.provider?.type === 'oci' && (
                  <>
                    {isEdit && (
                      <Grid container alignItems="center" item xs={12} md={4}>
                        <Grid item xs={6}>
                          <FormControlLabel
                            classes={{
                              label: classes.switchLabel,
                              root: classes.tenancySwitchRoot,
                            }}
                            control={
                              <Switch
                                id="use-partner-tenancy"
                                size="small"
                                onChange={(_, value) =>
                                  setFieldValue(
                                    'provider.oci_config_profile_name',
                                    value
                                      ? null
                                      : values?.partner?.provider
                                          ?.oci_config_profile_name
                                  )
                                }
                                checked={
                                  values?.provider?.oci_config_profile_name ===
                                  null
                                }
                                name="partner_new_front"
                                classes={{
                                  colorSecondary: classes.switchChecked,
                                }}
                              />
                            }
                            label={i18n.t('USE_PARTNER_TENANCY_KEY')}
                          />
                        </Grid>
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          screenFields={[
                            {
                              gridXs: 6,
                              label: 'Tenancy',
                              stateKey:
                                values?.provider?.oci_config_profile_name ===
                                null
                                  ? 'partner.provider.oci_config_profile_name'
                                  : 'provider.oci_config_profile_name',
                              isSelect: true,
                              options: [
                                {
                                  value: 'DEFAULT',
                                  label: 'Skyone Cloud 01',
                                },
                                {
                                  value: 'SKYONECLOUD02',
                                  label: 'Skyone Cloud 02',
                                },
                                {
                                  value: 'SKYONECLOUD03',
                                  label: 'Skyone Cloud 03',
                                },
                                {
                                  value: 'PARCEIRO-SIESA',
                                  label: 'Parceiro Siesa',
                                },
                                {
                                  value: 'PARCEIRO-DMA',
                                  label: 'Parceiro DMA',
                                },
                              ],
                              disabled:
                                values?.provider?.oci_config_profile_name ===
                                null,
                            },
                          ]}
                        />
                      </Grid>
                    )}
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields(
                        screenFields.generalSettings.slice(4, 5)
                      ).map(item => ({
                        ...item,
                        gridMd: isEdit ? 8 : 12,
                      }))}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                  </>
                )}
                {isEdit && (
                  <Grid container>
                    <InputAdornmentChip
                      {...filterFields([screenFields.generalSettings[5]])[0]}
                      values={
                        values?.trusted_users?.split(',').filter(Boolean) || []
                      }
                      setFieldValue={setFieldValue}
                    />
                  </Grid>
                )}
                {values?.provider?.type !== 'multicloud' && (
                  <>
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields([
                        {
                          gridXs: 12,
                          gridMd: 4,
                          label: i18n.t('REGION_KEY'),
                          stateKey: 'provider.region',
                          isSelect: true,
                          validateOnChange: true,
                          disabled: isEdit,
                          options: listProviderResources?.regions[
                            values?.provider.type
                          ]?.map(value => ({
                            value,
                            label: value,
                          })),
                        },
                      ])}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields(
                        screenFields.generalSettings.slice(6, 8)
                      ).map(field =>
                        makeOptionsProductType(
                          field,
                          values?.product,
                          values?.provider.type
                        )
                      )}
                      setFieldValue={(key, value) => {
                        setFieldValueByProductType(key, value, setFieldValue);
                      }}
                      errors={errors}
                    />
                  </>
                )}
                <SwitchComponent
                  id="toggle-auto-increase-licenses"
                  label={i18n.t('AUTO_INCREASE_LICENSES_KEY')}
                  onChange={(e, value) =>
                    setIncreaseLicenseLimitDefaultValue(value, setFieldValue)
                  }
                  isChecked={!!values?.licenses?.increase_license_limit_each}
                  hidden={!isEdit}
                  tooltipTitle={i18n.t(
                    'AUTO_INCREASE_LICENSES_EXPLANATION_KEY'
                  )}
                >
                  <GenericForm
                    overrideClasses={{
                      selectLabel: { fontSize: 12, fontWeight: 500 },
                    }}
                    fields={values}
                    screenFields={filterFields([
                      {
                        gridXs: 12,
                        gridMd: 2,
                        label: i18n.t('INCREASE_LICENSES_BY_KEY'),
                        stateKey: 'licenses.increase_license_limit_each',
                        type: 'number',
                      },
                    ])}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                  <TooltipMaterial
                    title={i18n.t('ALWAYS_ACTIVE_RESOURCE_TOOLTIP_KEY')}
                    arrow
                    placement="bottom"
                  >
                    <Grid item xs={4}>
                      <GenericForm
                        overrideClasses={{
                          selectLabel: { fontSize: 12, fontWeight: 500 },
                          checkboxLabel: { fontSize: 12 },
                        }}
                        fields={values}
                        screenFields={filterFields([
                          {
                            gridXs: 12,
                            gridMd: 12,
                            label: i18n.t('ALWAYS_ACTIVE_RESOURCE_KEY'),
                            stateKey:
                              'licenses.bypass_increase_license_auto_disable',
                            isCheckbox: true,
                          },
                        ])}
                        setFieldValue={setFieldValue}
                        errors={errors}
                      />
                    </Grid>
                  </TooltipMaterial>
                  <GenericForm
                    overrideClasses={{
                      selectLabel: { fontSize: 12, fontWeight: 500 },
                    }}
                    fields={values}
                    screenFields={filterFields([
                      {
                        gridXs: 12,
                        gridMd: 12,
                        label: i18n.t('REASON_KEY'),
                        stateKey: 'licenses.increase_license_reason',
                      },
                    ])}
                    setFieldValue={setFieldValue}
                    errors={errors}
                  />
                </SwitchComponent>
                <SwitchComponent
                  id="toggle-licenses-limit-per-client"
                  label={i18n.t('LICENSE_LIMIT_PER_CLIENT_KEY')}
                  onChange={(e, value) =>
                    setFieldValue('licenses.control_licenses_by_client', value)
                  }
                  isChecked={!!values?.licenses?.control_licenses_by_client}
                  hidden={!isEdit}
                  tooltipTitle={i18n.t(
                    'LICENSE_LIMIT_PER_CLIENT_EXPLANATION_KEY'
                  )}
                />
                <SwitchComponent
                  id="toggle-use-remote-dns"
                  label={i18n.t('USE_REMOTE_DNS_KEY')}
                  onChange={(e, value) =>
                    setFieldValue(
                      'user_connection.connect_by_dns_domain_name',
                      value
                    )
                  }
                  isChecked={
                    !!values?.user_connection?.connect_by_dns_domain_name
                  }
                  hidden={!isEdit}
                  tooltipTitle={i18n.t('USE_REMOTE_DNS_EXPLANATION_KEY')}
                />
                <SwitchComponent
                  id="toggle-connection-type-by-client"
                  label={i18n.t('USE_ALLOW_CLIENT_CONNECTION_TYPE_KEY')}
                  onChange={(e, value) =>
                    setFieldValue(
                      'user_connection.allow_client_connection_type',
                      value
                    )
                  }
                  isChecked={
                    !!values?.user_connection?.allow_client_connection_type
                  }
                  hidden={!isEdit}
                  tooltipTitle={i18n.t(
                    'USE_ALLOW_CLIENT_CONNECTION_TYPE_TOOLTIP_KEY'
                  )}
                />
                <SwitchComponent
                  id="toggle-block-multiple-sessions"
                  label={i18n.t('BLOCK_MULTIPLE_SESSIONS_KEY')}
                  onChange={(e, value) =>
                    setFieldValue(
                      'licenses.block_same_user_multiple_session',
                      value
                    )
                  }
                  isChecked={
                    !!values?.licenses?.block_same_user_multiple_session
                  }
                  hidden={!isEdit}
                  tooltipTitle={i18n.t(
                    'BLOCK_MULTIPLE_SESSIONS_EXPLANATION_KEY'
                  )}
                />
                <SwitchComponent
                  id="toggle-use-ios-by-default"
                  label={i18n.t('USE_IOS_BY_DEFAULT_KEY')}
                  onChange={(e, value) =>
                    setFieldValue('user_connection.use_ios_by_default', value)
                  }
                  isChecked={!!values?.user_connection?.use_ios_by_default}
                  hidden={!isEdit}
                  tooltipTitle={i18n.t('USE_IOS_BY_DEFAULT_EXPLANATION_KEY')}
                />
                <SwitchComponent
                  id="toggle-unique-user-session-validation"
                  label={i18n.t('UNIQUE_USER_SESSION_VALIDATION_KEY')}
                  onChange={(e, value) =>
                    setFieldValue(
                      'user_connection.unique_user_session_validation',
                      value
                    )
                  }
                  isChecked={
                    !!values?.user_connection?.unique_user_session_validation
                  }
                  hidden={!isEdit}
                  tooltipTitle={i18n.t(
                    'UNIQUE_USER_SESSION_VALIDATION_EXPLANATION_KEY'
                  )}
                />
                {!isClientOperator(role) && (
                  <>
                    <SwitchComponent
                      id="toggle-auth-without-ad"
                      label={i18n.t('AUTH_WITHOUT_AD_KEY')}
                      onChange={(e, checked) =>
                        setFieldValue(
                          'user_access_without_ad.enabled',
                          !!checked
                        )
                      }
                      isChecked={
                        values?.user_access_without_ad?.enabled === true
                      }
                      hidden={!isEdit}
                    />
                    <SwitchComponent
                      id="toggle-instance-observability"
                      label={i18n.t(
                        'INSTANCE_OBSERVABILITY.ENVIRONMENT_FORM_ENABLED_KEY'
                      )}
                      onChange={(e, checked) =>
                        setFieldValue(
                          'instance_observability.enabled',
                          !!checked
                        )
                      }
                      isChecked={
                        values?.instance_observability?.enabled === true
                      }
                      hidden={!isEdit}
                      tooltipTitle={i18n.t(
                        'INSTANCE_OBSERVABILITY.ENVIRONMENT_FORM_TOOLTIP_KEY'
                      )}
                    />
                  </>
                )}

                {isEdit && (
                  <>
                    <TitleDividerComponent
                      tooltipTitle={i18n.t('PROVIDER_CLOUD_TOOLTIP_KEY')}
                    >
                      {i18n.t('PROVIDER_CLOUD_KEY')}
                    </TitleDividerComponent>
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields([
                        {
                          gridXs: 11,
                          gridMd: 5,
                          label: i18n.t('MODEL_KEY'),
                          stateKey: 'scale_instances.main_model_uuid',
                          isSelect: true,
                          options: environmentModel.map(item => ({
                            label: formatModelName(
                              item?.name,
                              item?.description
                            ),
                            value: item?.model_uuid,
                          })),
                        },
                      ])}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                    <Tooltip title={i18n.t('MODEL_TOOLTIP_KEY')} />
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields([
                        {
                          gridXs: 11,
                          gridMd: 5,
                          label: i18n.t('MODEL_BACKUP_KEY'),
                          stateKey: 'scale_instances.backup_model_uuid',
                          isSelect: true,
                          options: environmentModel.map(item => ({
                            label: formatModelName(
                              item?.name,
                              item?.description
                            ),
                            value: item?.model_uuid,
                          })),
                        },
                      ])}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                    <Tooltip title={i18n.t('MODEL_TOOLTIP_BACKUP_KEY')} />
                    {values?.provider?.type !== 'multicloud' && (
                      <>
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          screenFields={filterFields([
                            {
                              gridXs: 11,
                              gridMd: 5,
                              label: i18n.t('ZONE_DEFAULT_KEY'),
                              stateKey: 'provider.default_zone',
                              isSelect: true,
                              options: listProviderResources?.zones[
                                values?.provider?.type
                              ][values?.provider?.region]?.map(value => ({
                                value,
                                label: value,
                              })),
                            },
                          ])}
                        />
                        <Tooltip title={i18n.t('ZONE_DEFAULT_TOOLTIP')} />
                      </>
                    )}
                    {values?.provider?.type !== 'multicloud' && (
                      <>
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          screenFields={filterFields([
                            {
                              gridXs: 11,
                              gridMd: 5,
                              label: i18n.t('CONNECTION_TYPE_KEY'),
                              stateKey: 'user_connection.network_type',
                              isSelect: true,
                              options: [
                                {
                                  value: 'public',
                                  label: i18n.t('ACCESS_PUBLIC_KEY'),
                                },
                                {
                                  value: 'private',
                                  label: i18n.t('PRIVATE_PUBLIC_KEY'),
                                },
                              ],
                            },
                          ])}
                        />
                        <Tooltip title={i18n.t('CONNECTION_TYPE_TOOLTIP')} />
                      </>
                    )}
                    {initialValues?.behavior?.type === 'spot_period' && (
                      <Grid
                        container
                        alignItems="center"
                        className={classes.spotGrid}
                      >
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          screenFields={filterFields([
                            {
                              gridXs: 10,
                              gridMd: 5,
                              label: i18n.t('MODEL_SPORT_KEY'),
                              stateKey: 'scale_instances.spot_model_uuid',
                              isSelect: true,
                              options: environmentModel.map(item => ({
                                label: formatModelName(
                                  item?.name,
                                  item?.description
                                ),
                                value: item?.model_uuid,
                              })),
                            },
                          ])}
                          setFieldValue={setFieldValue}
                          errors={errors}
                        />
                        <Slider
                          gridXs={12}
                          value={
                            initialValues?.scale_instances?.spot_threshold || 0
                          }
                          stateKey="scale_instances.spot_threshold"
                          setFieldValue={setFieldValue}
                          label={i18n.t('PERCENTAGE_SPOT_KEY')}
                          overrideClasses={overrideSlider}
                          tooltip={'MODEL_TOOLTIP_SPOT_KEY'}
                        />
                        <Typography className={classes.spotThreshold}>
                          {`Spot ${Number(
                            values?.scale_instances?.spot_threshold
                          )}%`}
                        </Typography>
                      </Grid>
                    )}
                    <TitleDividerComponent>
                      {i18n.t('USERS_KEY')}
                    </TitleDividerComponent>
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields(
                        screenFields.users.slice(
                          0,
                          WEB_PORT_VIRTUALIZERS.includes(
                            values?.user_connection?.virtualizer
                          )
                            ? 3
                            : 2
                        )
                      )}
                      setFieldValue={setFieldValue}
                      changeField={({ key, value }) => {
                        changeFieldValueByVirtualizer(
                          key,
                          value,
                          setFieldValue
                        );
                      }}
                      errors={errors}
                    />
                    {['connect', 'connect_direct'].includes(
                      values?.user_connection?.virtualizer
                    ) && (
                      <GenericForm
                        overrideClasses={{
                          selectLabel: { fontSize: 12, fontWeight: 500 },
                        }}
                        fields={values}
                        screenFields={filterFields(
                          screenFields.users.slice(3, 4)
                        )}
                        setFieldValue={setFieldValue}
                        errors={errors}
                      />
                    )}
                    <TitleDividerComponent>
                      {i18n.t('PUBLICATIONS_KEY')}
                    </TitleDividerComponent>
                    <Grid item xs={12} className={classes.publicationHeader}>
                      <GenericForm
                        overrideClasses={{
                          selectLabel: { fontSize: 12, fontWeight: 500 },
                        }}
                        fields={values}
                        screenFields={filterFields([
                          {
                            ...screenFields.publications[0],
                            disabled: values?.provider?.type === 'aws',
                          },
                        ])}
                        setFieldValue={setFieldValue}
                        errors={errors}
                      />
                      <Checkbox
                        className={classes.publicationCheckbox}
                        onChange={() => {
                          setUseDailyPublicationsLimit(
                            !useDailyPublicationsLimit
                          );
                        }}
                        checked={useDailyPublicationsLimit}
                      />
                      <Typography className={classes.useLimitDailyText}>
                        {i18n.t('USE_LIMIT_DAILY')}
                      </Typography>
                    </Grid>
                    <Grid container className={classes.publicationContainer}>
                      <GenericForm
                        overrideClasses={{
                          selectLabel: { fontSize: 12, fontWeight: 500 },
                        }}
                        fields={values}
                        screenFields={filterFields(
                          screenFields.publications.slice(1, 2)
                        )}
                        setFieldValue={setFieldValue}
                        errors={errors}
                      />
                      <Grid item xs={6} md={3} className={classes.currentTime}>
                        <TextField
                          id="executed-instance-blocking-publications"
                          label={i18n.t('TOTAL_PUBLICATIONS_KEY')}
                          value={
                            values?.publication
                              .executed_instance_blocking_publications
                          }
                          variant="outlined"
                          type="number"
                          InputProps={{ readOnly: true }}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                    <Grid container className={classes.publicationContainer}>
                      <Grid item xs={12} md={4}>
                        <TextField
                          label={i18n.t('MAX_DAILY_PUBLICATIONS_KEY')}
                          value={
                            !useDailyPublicationsLimit
                              ? ''
                              : dailyPublicationsLimit
                          }
                          onKeyDown={evt =>
                            ['e', 'E', '+', '-'].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          error={
                            useDailyPublicationsLimit &&
                            (dailyPublicationsLimit === null ||
                              dailyPublicationsLimit === '')
                          }
                          onChange={({ target }) => {
                            if (dailyPublicationsLimit === '') {
                              setDailyPublicationsLimit(null);
                            }
                            setDailyPublicationsLimit(
                              target.value === '' ? null : Number(target.value)
                            );
                          }}
                          variant="outlined"
                          type="number"
                          helperText={
                            useDailyPublicationsLimit &&
                            dailyPublicationsLimit === null &&
                            i18n.t('REQUIRED_FIELD_KEY')
                          }
                          InputProps={{
                            readOnly: !useDailyPublicationsLimit,
                          }}
                          disabled={!useDailyPublicationsLimit}
                        />
                      </Grid>
                      <Grid item xs={6} md={3} className={classes.currentTime}>
                        <TextField
                          id="executed-instance-blocking-publications-daily"
                          label={i18n.t('TOTAL_DAILY_PUBLICATIONS_KEY')}
                          value={
                            values?.publication
                              .executed_instance_blocking_publications_daily
                          }
                          variant="outlined"
                          type="number"
                          InputProps={{ readOnly: true }}
                          disabled={true}
                        />
                      </Grid>
                    </Grid>
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields(
                        screenFields.publications.slice(3, 4)
                      )}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                    <TitleDividerComponent
                      tooltipTitle={i18n.t('SCHEDULE_PUBLICATIONS_TOOLTIP_KEY')}
                    >
                      {i18n.t('SCHEDULE_PUBLICATIONS_KEY')}
                    </TitleDividerComponent>
                    <Grid
                      container
                      alignItems="center"
                      spacing={2}
                      className={classes.applicationsGrid}
                    >
                      <Grid item xs={12} md={6}>
                        <GenericForm
                          overrideClasses={{
                            selectLabel: { fontSize: 12, fontWeight: 500 },
                          }}
                          fields={values}
                          screenFields={filterFields([
                            {
                              gridXs: 12,
                              label: i18n.t('SCHEDULED_BLOCK_INSTANCES_KEY'),
                              stateKey:
                                'publication.schedule_instances_blocking_check',
                              isSelect: true,
                              options: [
                                { value: 'true', label: i18n.t('YES_KEY') },
                                { value: 'false', label: i18n.t('NO_KEY') },
                              ],
                            },
                          ])}
                          setFieldValue={(key, value) => {
                            if (value === 'false') {
                              setFieldValue(
                                'publication.schedule_instances_blocking',
                                {
                                  time: null,
                                  warning_emails: null,
                                }
                              );
                            }
                            setFieldValue(key, value);
                          }}
                          errors={errors}
                        />
                      </Grid>

                      {values?.publication
                        ?.schedule_instances_blocking_check === 'true' && (
                        <>
                          <Grid item xs={12} md={6}>
                            <DatePicker
                              id="first_period-hour"
                              type="time"
                              label={i18n.t('START_TIME_KEY')}
                              keyValue="publication.schedule_instances_blocking.time"
                              value={
                                values?.publication?.schedule_instances_blocking
                                  .time
                              }
                              setFieldsValue={setFieldValue}
                            />
                          </Grid>
                          <Grid container>
                            <InputAdornmentChip
                              {...filterFields([
                                screenFields.publications[5],
                              ])[0]}
                              values={
                                values?.publication?.schedule_instances_blocking?.warning_emails
                                  ?.split(',')
                                  .filter(Boolean) || []
                              }
                              setFieldValue={setFieldValue}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                    <TitleDividerComponent
                      tooltipTitle={i18n.t('APPLICATIONS_TOOLTIP_KEY')}
                    >
                      {i18n.t('APPLICATIONS_KEY')}
                    </TitleDividerComponent>
                    <GenericForm
                      overrideClasses={{
                        selectLabel: { fontSize: 12, fontWeight: 500 },
                      }}
                      fields={values}
                      screenFields={filterFields(
                        values?.client_apps?.registration_source === 'platform'
                          ? screenFields.applications.slice(0, 1)
                          : screenFields.applications
                      )}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                  </>
                )}

                <Grid container justify="flex-end" className={classes.buttons}>
                  <Button
                    id="submit-button"
                    submitButton
                    onClick={() =>
                      values?.user_connection?.connect_by_dns_domain_name &&
                      isEdit
                        ? modalOpen({
                            title: i18n.t('EDIT_ENVIRONMENT'),
                            content: (
                              <Typography>
                                {i18n.t('ACTIVE_DNS_WARN_KEY', {
                                  virtualizer: mapVirtualizer(
                                    values?.user_connection?.virtualizer
                                  ),
                                })}
                              </Typography>
                            ),
                            noBorder: true,
                            footer: (
                              <Grid>
                                <Button
                                  submitButton
                                  id="confirm-button"
                                  onClick={() => {
                                    submitForm();
                                    modalClose();
                                  }}
                                >
                                  {i18n.t('CONFIRM_KEY')}
                                </Button>
                                <Button
                                  id="cancel-button"
                                  variant="outlined"
                                  onClick={modalClose}
                                >
                                  {i18n.t('CANCEL_KEY')}
                                </Button>
                              </Grid>
                            ),
                          })
                        : submitForm()
                    }
                    disabled={
                      isLoading ||
                      !isValid ||
                      dateError ||
                      (useDailyPublicationsLimit &&
                        (dailyPublicationsLimit === null ||
                          dailyPublicationsLimit === ''))
                    }
                  >
                    {isLoading ? (
                      <CircularProgress size={15} />
                    ) : (
                      i18n.t('SAVE_KEY')
                    )}
                  </Button>
                  <Button
                    id="cancel-button"
                    variant="outlined"
                    onClick={() =>
                      history.push(
                        !companySelected && superUser(role)
                          ? '/all-environments'
                          : '/environments'
                      )
                    }
                  >
                    {i18n.t('CANCEL_KEY')}
                  </Button>
                  {isEdit && (
                    <Permission value="delete_environment">
                      <Button
                        deleteButton
                        id="delete-button"
                        onClick={handleRemoveEnvironment}
                      >
                        {i18n.t('REMOVE_KEY')}
                      </Button>
                    </Permission>
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </Formik>
      </Grid>
    </>
  ) : (
    <Alert className={classes.alert} severity="warning" color="info">
      <span>{i18n.t('CREATE_ENVIRONMENT_COMPANY_AND_PARTNER_KEY')}</span>
    </Alert>
  );
};

const mapStateToProps = ({
  authenticate: { partnerSelected, companySelected, data },
  environments: {
    providerResources: { listProvidersResources },
  },
  partners: { partnerDetails },
}: ApplicationState) => ({
  companySelected,
  partnerDetails,
  partnerSelected,
  permissions: data?.permissions,
  providerResources: listProvidersResources,
  role: data?.role,
});

export default connect(mapStateToProps, {
  getEnvironmentMonitoringRequest,
  getPartnerRequest,
  getProviderResourcesRequest,
  modalOpen,
  modalClose,
  removeEnvironmentRequest,
  setProductionEnvironmentRequest,
  acceptStatusPendingRequest,
  extendCompletionDateRequest,
})(FormEnvironment);
